export default "/images/b4b1a90fa2387af4843c017884153b17.avif";